import React from "react";

function Create() {
  return (
    <div>
      <h1>Create Question</h1>
      <p>Add</p>
    </div>
  );
}

export default Create;
